<template>
  <ts-layout
    useDefaultNavbar="{{useDefaultNavbar}}"
    navbarTitle="{{title}}"
    navbarStyle="{{navbarStyle}}"
    leftArrow="{{leftArrow}}"
    bind:clickleft="closePopup"
  >
    <search-input
      ref="keywordInput"
      placeholder="{{title}}"
      bindinput="searchCity"
      bind:clear="close"
    />
    <view class="city-container">
      <!--  城市列表  -->
      <city-scroll-list
        ref="cityScrollList"
        wx:if="{{(allCities.length || allHotCities.length) && !isShowSearchResult}}"
        list="{{allCities}}"
        bindhandle="updateCity"
        showAnchorFloat
        showSingleCity
      >
        <city-location list="{{allCities}}" title="当前定位" bindhandle="updateCity" />
        <city-history
          wx:if="{{flightsSearchHistoryValid.length}}"
          list="{{flightsSearchHistoryValid}}"
          title="历史"
          bindhandle="updateCity"
          bindclear="clearHistory"
        />
        <city-label
          wx:if="{{allHotCities.length !== 0}}"
          list="{{allHotCities}}"
          title="热门城市"
          bindhandle="updateCity"
        />
      </city-scroll-list>
      <polyfillPage
        wx:if="{{!allCities.length && !isShowSearchResult}}"
        blankImageUrl="{{blankImageUrl}}"
        blankContextTitle="{{blankContextTitle}}"
        blankContextSubTitle="{{blankContextSubTitle}}"
        hasButton="{{hasButton}}"
        blankPageType="blank-page"
        bind:click-button="clickButton"
      />
      <!--  搜索页面  -->
      <scroll-view
        scroll-y="{{true}}"
        wx:style="{{ {  height: '100%', scrollBehavior: 'smooth'} }}"
        scroll-with-animation
      >
        <city-search
          wx:if="{{searchList.length && isShowSearchResult}}"
          list="{{searchList}}"
          label="{{searchListLabel}}"
          type="station_list"
          labelType="name"
          bindhandle="updateCity"
          bindrefresh="citySearchRefresh"
        />
        <polyfillPage
          wx:if="{{!searchList.length && isShowSearchResult}}"
          blankImageUrl="{{blankImageUrlSearch}}"
          blankContextTitle="{{blankContextTitleSearch}}"
          blankContextSubTitle="{{blankContextSubTitleSearch}}"
          hasButton="{{hasButtonSearch}}"
          blankPageType="blank-page"
          bind:click-button="clickButtonSearch"
        />
      </scroll-view>
    </view>
    <choosed-city
      wx:if="{{selectType === 'mutiple'}}"
      slot="footer"
      citys="{{choosedCitys}}"
      bindcancel="onCancel"
      binddelete="onDelete"
      bindconfirm="updateMutipleCityConfirm"
    />
  </ts-layout>
</template>

<style lang="stylus" scoped>
  .city-container
    height calc(100% - 45px)
    background #ffffff
</style>

<script>
  import mpx, { createComponent } from '@mpxjs/core'
  import webviewBridge from '@mpxjs/webview-bridge'
  import { query, post, get, uniqBy } from '@didi/spring-base'

  const { navigateBack, postMessage } = webviewBridge

  const LOAD_FAIL_CONTENT = '请检查网络设置或稍后重试'
  const FLIGHTS_SEARCH_HISTORY = 'flights_city_search_history'
  const FLIGHTS_SEARCH_HISTORY_MAX = 6

  const getTrainCityList = () => {
    return post('https://travel.xiaojukeji.com/train-toc/queryCityList')
  }
  const getTrainCityListByKeyword = (data) => {
    return post('https://travel.xiaojukeji.com/train-toc/queryCityStationNameByKeyword', data)
  }
  // 获取全量城市列表
  const getAllFlightsCitys = () => {
    return get('https://merak-flight.xiaojukeji.com/search-api/base/get_all_citys')
  }

  // 根据城市/机场关键字获取机场列表
  const getAirportsByKeyword = (params) => {
    return get('https://merak-flight.xiaojukeji.com/search-api/base/get_airports_by_keyword', params)
  }
  const DEFAULT_FROM = {
    city_id: 'BJS',
    city_name: '北京',
    id: '',
    name: ''
  }
  const DEFAULT_TO = {
    city_id: 'SHA',
    city_name: '上海',
    id: '',
    name: ''
  }
  createComponent({
    props: {
      bizType: {
        type: String,
        value: 'train' // flights
      },
      searchLabel: {
        type: String,
        value: '火车站'
      },
      placeHolder: {
        type: String,
        value: '城市/车站的中文或拼音'
      },
      editCityType: {
        type: String,
        value: 'currentToCity'
      },
      token: {
        type: String,
        value: ''
      },
      leftArrow: {
        type: Boolean,
        value: false
      },
      useDefaultNavbar: {
        type: Boolean,
        value: false
      },
    },
    data: {
      navbarStyle: {
        background: '#ffffff',
        'font-size': '18px',
        'font-weight': 600,
        color: '#000000',
        'margin-bottom': '12px'
      },
      isShowSearchResult: false,
      // location: {},
      blankImageUrl: null,
      blankContextTitle: '',
      blankContextSubTitle: '',
      hasButton: false,
      blankImageUrlSearch: null,
      blankContextTitleSearch: '',
      blankContextSubTitleSearch: '',
      hasButtonSearch: false,
      searchKey: '',
      selectType: 'single',
      maxChoosedCitysLength: 3,
      choosedCitys: [],
      canRenderList: false,
      trainCities: [], // 城市列表
      trainHotCities: [], // 热门城市列表
      trainSearchRetList: [], // 搜索城市列表
      airports: [],
      cityAirports: [],
      flightsProvinces: [],
      flightsCities: [],
      flightsHotCities: [],
      flightsQuery: {},
      currentFromCity: {},
      currentToCity: {},
      flightsSearchHistory: []
    },
    computed: {
      flightsSearchHistoryValid() {
        return this.flightsSearchHistory.filter((i) => {
          return this.flightsCities.find(({ city_list = [] }) => {
            return city_list.find(({ city_id }) => city_id === i.city_id)
          })
        })
      },
      allCities() {
        return this.bizType === 'flights' ? this.flightsCities : this.trainCities
      },
      allHotCities() {
        const _allHotCitys = this.bizType === 'flights' ? this.flightsHotCities : this.trainHotCities
        const _choosedCitysMap = this.choosedCitys.reduce((a, b) => {
          a[b.city_id] = true
          return a
        }, {})
        return _allHotCitys.map((i) => ({
          ...i,
          isChoosed: _choosedCitysMap[i.city_id]
        }))
      },
      travelType() {
        if (this.isCallbackPage) {
          return query().travelType === 'fromCity' ? 'from' : 'to'
        }
        if (this.bizType === 'flights') {
          return query().type // from to
        } else {
          return this.editCityType === 'currentToCity' ? 'to' : 'from'
        }
      },
      title() {
        if (this.bizType === 'flights') {
          return ''
        }
        return this.travelType === 'to' ? '选择目的地' : '选择出发地'
      },
      searchListLabel() {
        return this.bizType === 'flights' ? '机场' : '火车站'
      },
      searchList() {
        if (this.bizType === 'flights') {
          return this.flightsSearchRetList
        } else {
          return this.trainSearchRetList
        }
      },
      isCallbackPage() {
        return query().as_cb_page === '1'
      },
      flightsSearchRetList() {
        return this.cityAirports.concat(this.airports, this.flightsProvinces)
      },
      selectCitys() {
        const {
          fromCitys = DEFAULT_FROM,
          toCitys = DEFAULT_TO,
          spFromCitys = DEFAULT_FROM,
          spToCitys = DEFAULT_TO
        } = this.flightsQuery
        return {
          fromCitys,
          toCitys,
          // 特价
          spFromCitys,
          spToCitys
        }
      }
    },
    methods: {
      changeSelectCityList(payload) {
        const { type, data } = payload
        this[type] = data
      },
      onCancel() {
        if (this.isCallbackPage) {
          if (is('passenger')) {
            bridge.closePage()
          } else if (is('miniprogram')) {
            navigateBack()
          }
          return
        }
      },
      onDelete({ detail }) {
        this.updateChoosedCitys(detail)
      },
      updateChoosedCitys({ city_id, city_name }) {
        const _targetIdx = this.choosedCitys.findIndex((item) => item.city_id === city_id)
        if (_targetIdx > -1) {
          this.choosedCitys.splice(_targetIdx, 1)
        } else if (this.choosedCitys.length >= this.maxChoosedCitysLength) {
          mpx.showToast({
            title: '最多可选3个城市',
            icon: 'none'
          })
        } else {
          this.choosedCitys.push({
            city_id,
            city_name,
            name: city_name,
            id: city_id
          })
        }
      },
      callBackPageHandle(type, params) {
        if (is('passenger')) {
          bridge.callHandler('setResultData', {
            type,
            data: params
          })
          bridge.closePage()
        } else if (is('miniprogram')) {
          postMessage({
            data: {
              type: 'yks-city',
              result: {
                type,
                data: params
              }
            },
            success(res) {
            }
          })
          navigateBack()
        }
      },
      updateCity({ detail }) {
        if (this.selectType === 'mutiple') {
          this.updateChoosedCitys(detail)
          return
        }
        const { city_id, city_name, name, id, type } = detail
        if (this.bizType === 'train') {
          if (this.isCallbackPage) {
            this.callBackPageHandle('single', {
              city_id,
              city_name,
              name: name || city_name
            })
            return
          }
          const city = {
            id: city_id,
            city_id,
            city_name: name || city_name,
            name: name || city_name,
            precise_search: '0',
            subName: city_name
          }
          const params = { type: this.editCityType, data: city }
          this.changeSelectCityList(params)
          this.triggerEvent('changeCity', { data: city })
        } else if (this.bizType === 'flights') {
          const cityRet = {
            city_id,
            city_name,
            name: name || city_name,
            id: id || city_id,
            type: type || 0 // 0国内城市 2国内机场
          }
          this.triggerEvent('confirm', cityRet)
          this.refreshFlightsSearchHistory(cityRet)
          this.showInitalStatus()
        }
      },
      clearHistory() {
        mpx.setStorageSync(FLIGHTS_SEARCH_HISTORY, [])
        this.flightsSearchHistory = []
      },
      refreshFlightsSearchHistory(cityRet) {
        let history = mpx.getStorageSync(FLIGHTS_SEARCH_HISTORY) || []
        if (cityRet) {
          history.unshift(cityRet)
          history = uniqBy(history, (item) => `${item.city_id}-${item.id}`)
          history.splice(FLIGHTS_SEARCH_HISTORY_MAX)
          mpx.setStorageSync(FLIGHTS_SEARCH_HISTORY, history)
        }
        this.flightsSearchHistory = history
      },
      showInitalStatus() {
        this.$refs.keywordInput.clear()
        this.$nextTick(() => {

          this.$refs.cityScrollList?.scrollToViewFn && this.$refs.cityScrollList.scrollToViewFn({
            target: {
              dataset: {
                id: '-1'
              }
            }
          })
        })
      },
      updateMutipleCityConfirm() {
        if (!this.choosedCitys.length) {
          mpx.showToast({
            title: '至少选择一个城市',
            icon: 'none'
          })
          return
        }
        if (this.isCallbackPage) {
          this.callBackPageHandle('mutiple', this.choosedCitys)
          return
        }
        const _query =
          this.travelType === 'to'
            ? { spToCitys: this.choosedCitys }
            : { spFromCitys: this.choosedCitys }
        this.setFlightsQuery(_query)
      },
      /**
       * @description: 搜索
       */
      searchCity({ detail }) {
        this.searchKey = detail
        this.getCityListByKeyword()
      },

      /**
       * @description: 清空
       */
      close() {
        this.searchKey = ''
        this.isShowSearchResult = false
      },
      getTrainCityListFunc() {
        this.getTrainCityList().then((res) => {
          const { code, data } = res || {}
          const success = !!data
          if (success) {
            if (code === '0' && data?.cities?.length) {
              this.blankImageUrl = null
              this.blankContextTitle = ''
              this.blankContextSubTitle = ''
              this.hasButton = false
            } else {
              this.blankImageUrl =
                'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png' // 空数据
              this.blankContextTitle = '未找到符合条件的结果'
              this.blankContextSubTitle = '请更改站点重新查询'
              this.hasButton = false
            }
          } else {
            this.blankImageUrl =
              'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
            this.blankContextTitle = '加载失败'
            this.blankContextSubTitle = LOAD_FAIL_CONTENT
            this.hasButton = true
            return mpx.showToast({
              title: '站点查询失败',
              icon: 'error'
            })
          }
        })
      },
      getFlightsCityListFunc() {
        this.getFlightsCityList().then((ret) => {
          this.blankImageUrl = ret
            ? null
            : 'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png'
          this.blankContextTitle = ret ? '' : '未找到符合条件的结果'
          this.blankContextSubTitle = ret ? '' : '请重新查询'
          this.hasButton = false
        })
      },
      clickButton() {
        this.refreshCityList()
      },
      getFlightsCityListByKeywordFunc(query) {
        this.getFlightsCityListByKeyword(query).then((ret) => {
          this.blankImageUrlSearch = ret
            ? null
            : 'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png'
          this.blankContextTitleSearch = ret ? '' : '未找到符合条件的结果'
          this.blankContextSubTitleSearch = ret ? '' : '请重新查询'
          this.hasButtonSearch = false
        })
      },
      getTrainCityListByKeywordFunc(query) {
        this.getTrainCityListByKeyword(query).then((res) => {
          const { code, data } = res || {}
          const success = !!data
          if (success) {
            if (code === '0' && data?.stations?.length) {
              this.blankImageUrlSearch = null
              this.blankContextTitleSearch = ''
              this.blankContextSubTitleSearch = ''
              this.hasButtonSearch = false
            } else {
              this.blankImageUrlSearch =
                'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png' // 空数据
              this.blankContextTitleSearch = '未找到符合条件的结果'
              this.blankContextSubTitleSearch = '请更改站点重新查询'
              this.hasButtonSearch = false
            }
          } else {
            this.blankImageUrlSearch =
              'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
            this.blankContextTitleSearch = '加载失败'
            this.blankContextSubTitleSearch = LOAD_FAIL_CONTENT
            this.hasButtonSearch = true
            return mpx.showToast({
              title: '站点查询失败',
              icon: 'error'
            })
          }
        })
      },
      clickButtonSearch() {
        this.getCityListByKeyword()
      },
      citySearchRefresh() {
        /**
         * 搜索城市点击点击 展开/折叠 按钮后，需要强制刷新
         * 不然会出现scroll-view无法滚动的情况
         */
        this.$forceUpdate()
      },
      getCityListByKeyword() {
        const ticket = this.token || query().token || query().ticket || ''
        const params = { keyword: this.searchKey, ticket }
        this.isShowSearchResult = true
        if (this.bizType === 'train') {
          this.getTrainCityListByKeywordFunc(params)
        } else if (this.bizType === 'flights') {
          this.getFlightsCityListByKeywordFunc(params)
        }
      },
      refreshCityList() {
        const { selectType = 'single' } = query()
        this.selectType = selectType
        if (this.bizType === 'train') {
          this.getTrainCityListFunc()
        } else if (this.bizType === 'flights') {
          this.getFlightsCityListFunc()
        }
      },
      initMutiplePageData() {
        if (this.isCallbackPage) {
          const _choosedCitys = query().choosedCitys
          this.choosedCitys = _choosedCitys ? JSON.parse(_choosedCitys) : []
          return
        }
        if (this.bizType === 'flights') {
          const { spFromCitys, spToCitys } = this.selectCitys
          this.choosedCitys = this.travelType === 'to' ? spToCitys : spFromCitys
        }
      },
      getTrainCityList(options) {
        return getTrainCityList(options).then((res) => {
          const { code, data } = res || {}
          const success = !!data
          if (data || code == '0') {
            const { cities = [], hot_city_list = [] } = data
            this.trainCities = cities
            this.trainHotCities = hot_city_list
          }
          return res
        })
      },
      getTrainCityListByKeyword(options) {
        mpx.showLoading()
        return getTrainCityListByKeyword(options)
          .then((res) => {
            const { code, data } = res || {}
            const success = !!data
            if (data || code == '0') {
              this.trainSearchRetList = data?.stations ?? []
            }
            return res
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      setSearchList(payload = {}) {
        const { airports = [], cityAirports = [], provinces = [] } = payload
        this.cityAirports = this.formatAirPortData(cityAirports)
        this.airports = this.formatAirPortData(airports)
        this.flightsProvinces = this.formatAirPortData(provinces)
      },
      setAllFlightsCityList(payload = {}) {
        const { citys = {}, hotCitys = [] } = payload
        this.flightsCities = Object.keys(citys).reduce((ret, k) => {
          return ret.concat({
            first_upper_letter: k,
            city_list: citys[k].map(({ cityCode, cityName, cityId }) => ({
              city_id: cityCode,
              city_name: cityName,
              _cityId: cityId
            }))
          })
        }, [])
        this.flightsHotCities = hotCitys.map(({ cityCode, cityName }) => ({
          city_id: cityCode,
          city_name: cityName
        }))
      },
      getFlightsCityList() {
        // 清空上次查询的数据 减少渲染时间
        this.setSearchList()
        // 避免重复请求城市列表
        if (this.flightsCities.length || this.flightsHotCities.length) {
          return true
        }
        return getAllFlightsCitys().then(({ data, code }) => {
          if (code === 200) {
            this.setAllFlightsCityList({ ...data })
            return true
          } else {
            return null
          }
        })
      },
      getFlightsCityListByKeyword(payload) {
        return getAirportsByKeyword(payload).then(({ data, code }) => {
          if (code === 200) {
            let { airports = [], cityAirports = [], provinces = [] } = data
            airports = airports || []
            cityAirports = cityAirports || []
            provinces = provinces || []
            this.setSearchList({ airports, cityAirports, provinces })
            return airports.length + cityAirports.length + provinces.length
          } else {
            return null
          }
        })
      },
      formatAirPortData(_airports) {
        return _airports.map(
          ({
            cityCode,
            cityName,
            airportCode,
            airportName,
            type,
            airports,
            provinceName,
            provinceCode,
            citys
          }) => ({
            city_id: cityCode,
            city_name: cityName,
            id: provinceCode || airportCode,
            name: provinceName || airportName,
            type: type || 0,
            citys: (citys || [])
              .filter(({ cityName }) => cityName)
              .map(({ cityName, cityCode }) => ({
                name: cityName,
                id: cityCode,
                city_id: cityCode,
                city_name: cityName,
                type: 0
              })),
            station_list: (airports || []).map(({ airportName, airportCode }) => ({
              name: airportName,
              id: airportCode,
              type: 2 // 2国内机场 0国内城市
            }))
          })
        )
      },
      setFlightsQuery(payload = {}) {
        const ret = {
          ...this.flightsQuery,
          ...payload
        }
        this.flightsQuery = ret
      },
      closePopup() {
        this.triggerEvent('close')
      }
    },
    created() {
      this.refreshFlightsSearchHistory()
      this.refreshCityList()
      if (this.selectType === 'mutiple') {
        this.initMutiplePageData()
      }
    },
    ready() {
      // 页面未加载直接渲染list列表过大会有卡顿体验
      this.canRenderList = true
    }
  })
</script>

<script name="json">
  module.exports = {
    usingComponents: {
      'ts-layout': '../ts-layout',
      'city-label': './cityLabel',
      'city-history': './cityHistory',
      'city-location': './cityLocation',
      'city-search': './citySearch',
      'search-input': './searchInput',
      polyfillPage: '../ts-polyfill-page',
      'city-scroll-list': './cityScrollList',
      'choosed-city': './choosed-city'
    }
  }
</script>
